import { HomeComponent } from './home/home.component';
import { Routes, RouterModule } from '@angular/router';
import { CeremonyComponent } from './ceremony/ceremony.component';
import { app } from 'firebase/app';
import { SearchComponent } from './components/search/search.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
    },
    { path: 'home', component: HomeComponent, data: { title: 'Những ngày vui của Dedo', name: 'Trang Chủ', hasChildren: false } },
    { path: 'search', component: SearchComponent, data: { title: 'Tìm kiếm hình ảnh', name: 'Tìm Kiếm', hasChildren: false } },
    { path: 'ceremony/:id', component: CeremonyComponent, data: { title: 'Những ngày vui của Dedo', name: 'Ngày vui', hasChildren: true } },
    { path: '**', redirectTo: 'home' },
];

let appRoutes = routes.filter(x => x.path != '' && x.path != '**' && !x.data.hasChildren);
appRoutes.push({ path: 'ceremony/:id', data: { title: 'Hình ảnh lễ', name: "Hình ảnh", hasChildren: true }, 
    children: [
        { path: 'ceremony/1', component: CeremonyComponent, data: { title: 'Đám hỏi', name: "Đám hỏi" } },
        { path: 'ceremony/2', component: CeremonyComponent, data: { title: 'Lễ cáo gia tiên', name: "Lễ cáo gia tiên" } },
        { path: 'ceremony/3', component: CeremonyComponent, data: { title: 'Lễ vu quy', name: "Lễ vu quy" } },
        { path: 'ceremony/4', component: CeremonyComponent, data: { title: 'Lễ thành hôn', name: "Lễ thành hôn" } },
        { path: 'ceremony/5', component: CeremonyComponent, data: { title: 'Lễ rước dâu', name: "Lễ rước dâu" } },
        { path: 'ceremony/6', component: CeremonyComponent, data: { title: 'Tiệc báo hỷ', name: "Tiệc báo hỷ" } }
    ] 
});

export class AppRoutes {
    Navs = appRoutes
}


// WEBPACK FOOTER //
// ./src/app/app.routing.ts